import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(_vm.layout,{tag:"component"}),_c('helper-maintenance-mode',{attrs:{"show-dialog":_vm.maintenanceDialog}}),_c('helper-version-dialog',{attrs:{"show-dialog":_vm.versionDialog,"version":_vm.appState}}),_c('helper-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }